import { ChangeDetectionStrategy, Component, ElementRef, inject, input, output } from '@angular/core';
import {
  IMenuWithPages,
  ActivitySectionDirective,
  MenuImageComponent,
  RestaurantTableService,
  UserActivityClickTrackingDirective,
} from '@core';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { toSignal } from '@angular/core/rxjs-interop';
import { map } from 'rxjs/operators';

@Component({
  selector: 'app-menu-pages',
  templateUrl: './pages.component.html',
  styleUrl: './pages.component.scss',
  imports: [
    ActivitySectionDirective,
    PageHeaderComponent,
    UserActivityClickTrackingDirective,
    MenuImageComponent,
  ],
  host: {
    class: 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PagesComponent {

  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);
  private readonly restaurantTable = inject(RestaurantTableService);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    element: this.elementRef.nativeElement,
  };

  public readonly back = output();

  public readonly menu = input.required<IMenuWithPages>();

  public readonly tableName = toSignal(this.restaurantTable.table$.pipe(
    map((table) => {
      return table ? table.tableName : undefined;
    }),
  ));

}
